import Header from "layout/Header2/Header"
import WhitSale from './WhiteSale'
import GreyListPreSale from './GreyPreSale'

const MintPage = () => {
    return (
        <section id="hero">
            <Header />
            <WhitSale />
            <GreyListPreSale />
        </section>
    )
}

export default MintPage
